import { Box, Link } from "@mui/material";
import color from "context/MaterialUITheme/color";

interface Prop {
  link?: string;
  logo?: string;
}
export default function CCustomLogo({ link, logo }: Prop) {
  return (
    <Box p={0}>
      <Link
        sx={{
          cursor: "pointer",
          color: color.primary,
          textDecoration: "none",
        }}
        href={link}
        target="_blank"
      >
        <img alt="img" style={{ height: 50 }} src={logo} />
      </Link>
    </Box>
  );
}
